(function (jQuery) {


    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.custom === "undefined") {
        jQuery.extend(sm.portal.vm, { custom: {} });
    }

    this.callCustomization = function (name, data, callback) {
        if(name){
            if (typeof(page_name) != 'undefined') {
                var funcName = sm.portal.vm.custom.common && sm.portal.vm.custom.common[name];
                if(!funcName) {
                    var postName = page_name;
                    if (sm.portal.vm.custom[postName]) {
                        funcName = sm.portal.vm.custom[postName][name];
                    }    
                }
                if(!funcName) {
                    callback && callback();
                }
                else {
                    return funcName(data, callback);
                } 
            }
            else {            
                callback && callback(); 
            }
        }else
            callback && callback();
    }
    
    this.setCustomLocalizeKey = function (data) {
        var customizedData = sm.portal.vm.custom.callCustomization('LocalizeKeys');
        if (customizedData) {
            Object.keys(customizedData).map(function (key) {
                if (data[key]) {
                    if (typeof(data[key]) == 'function') {
                        data[key](customizedData[key]);                        
                    }
                    else{
                        data[key] = customizedData[key];
                    }
                }

            });
        }
    }

    this.loadCustomTemplate = function () {
        if (typeof(page_name) != 'undefined') {
            var pageName = page_name;
            var clientId = window.u4sm_client_identification;
            var clientName = "";
            var data = sm.portal.vm.custom.callCustomization('LoadTemplates');
            if(window.u4sm_canada_enabled){
                clientName = "canada";
            }
            else{
                clientName = clientId && Object.keys(smapi.constant.client).find(key => smapi.constant.client[key] === clientId).toLowerCase();
            }
            if (pageName && clientName && data) {
    
                for (var index = 0; index < data.length; index++) {
                    var item = data[index];
                    var uri = '';
                    if (item.indexOf('.html') === -1) {
                        uri = U4SM_Adaptor_url.site_plugin_base_url + '/customization/assets/template/'+ clientName + '/' + pageName + '/' + item + '.html';
                    }
    
                    var element = document.createElement("DIV");
                    var target = pageName + '_' + index;
                    element.id = target;
                    document.body.appendChild(element);
    
                    jQuery.ajax({
                        url: uri,
                        success: function (template) {
                            jQuery("#" + target).append(template);
                        }
                    });
                }
            }            
        }
    }

    jQuery.extend(true, sm.portal.vm.custom, {
        callCustomization: callCustomization,
        setCustomLocalizeKey: setCustomLocalizeKey,
        loadCustomTemplate: loadCustomTemplate,
    });

})(jQuery);